module.exports = __webpack_public_path__ + "img/hybrid.cf49e725.svg";